import { DataBean } from "../DataBean";

export class MaterialAvailableProductionOrder extends DataBean {


    public async getRawMaterialAvailableProductionOrderCatalog(idProductionOrder:any,productionOrderDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getRawMaterialAvailableProductionOrderCatalog_Number_java.util.Date", [idProductionOrder,productionOrderDate]);
    }



}